// extracted by mini-css-extract-plugin
export default {"radioShack":"styles_radioShack__YP8ll","customOuter":"styles_customOuter__TWIR5"};